import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchUserNotification,
  fetchVendorNotification,
  sendNotification,
} from "./../services/api";

// Async actions
export const fetchUserNotifications = createAsyncThunk(
  "notifications/fetchUserNotifications",
  async () => {
    const response = await fetchUserNotification();
    return response;
  }
);

export const fetchVendorNotifications = createAsyncThunk(
  "notifications/fetchVendorNotifications",
  async () => {
    const response = await fetchVendorNotification();
    return response;
  }
);

export const sendNotificationAsync = createAsyncThunk(
  "notifications/sendNotification",
  async ({ title, body, view }, { rejectWithValue }) => {
    try {
      const response = await sendNotification(title, body, view);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const notificationsSlice = createSlice({
  name: "notifications",
  initialState: {
    users: [],
    vendors: [],
    status: "idle",
    error: null,
  },
  reducers: {
    // Add any additional reducers if needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserNotifications.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUserNotifications.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.users = action.payload.notifications;
      })
      .addCase(fetchUserNotifications.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchVendorNotifications.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchVendorNotifications.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.vendors = action.payload.notifications;
      })
      .addCase(fetchVendorNotifications.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(sendNotificationAsync.fulfilled, (state, action) => {
        // Optionally handle notification sent success
      });
  },
});

export default notificationsSlice.reducer;
